<template>
    <div>
        <component
            :is="params.comp"
            v-if="params.data !== undefined && val !== undefined && (params.value !== undefined || 'isCheckboxColumn' in params)"
            class="eq-grid-cell-renderer"
            v-bind="getComponentProps()"
            :value="val"
            :row="params.data"
            :grid="params.grid"
            :rowId="params.node.id"
        />
    </div>
</template>
<script setup lang="ts" generic="TRowData, TCell = any">
import { type ICellRendererParams } from 'ag-grid-community';
import type { ICellRendererComponentParams } from '../Classes/params';
import { useAgGridCellValueComputedWrapper } from '../Classes/AgGridCellValueComputedWrapper';
import { watch } from 'vue';

const props = defineProps<{
    params: ICellRendererParams & ICellRendererComponentParams<TRowData, TCell>;
}>();

/**
 * Gets the component props.
 * This is a function instead of just a variable so we dont evaluate it until the component actually renders, and the data is available.
 */
const getComponentProps = () =>
    props.params.componentProps instanceof Function ? props.params.componentProps(props.params.data) : props.params.componentProps;

// We use a computed for the value and get it from the data object which represents the row.
// This is so the inner component can keep the vue reactivity instead of losing it since the grid will only supply the primitive value in params.value.
const val = useAgGridCellValueComputedWrapper(props.params);

// If we have a cellRefreshTrigger we refresh the cell when the trigger triggers.
if (props.params.cellRefreshTrigger && props.params.refreshCell) {
    watch(
        () => {
            if (!props.params.data) {
                return '';
            }
            return props.params.cellRefreshTrigger(props.params.data, val.value);
        },
        () => {
            props.params.refreshCell!();
        },
    );
}

if (props.params.rowRefreshTrigger) {
    watch(
        () => {
            if (!props.params.data) {
                return '';
            }
            return props.params.rowRefreshTrigger(props.params.data);
        },
        () => {
            // Remark. This one messes with the edititing state and should be used with care
            // We remove it for now until we find a better way to do it
            // props.params.api.redrawRows({ rowNodes: [props.params.node] });
        },
    );
}
</script>
